import api from './client';

// Property costs and investment API
export const propertyCostsAPI = {
  listCosts: (propertyId) => api.get(`/properties/${propertyId}/recurring-costs`),
  createCost: (propertyId, data) => api.post(`/properties/${propertyId}/recurring-costs`, data),
  updateCost: (propertyId, costId, data) =>
    api.patch(`/properties/${propertyId}/recurring-costs/${costId}`, data),
  deleteCost: (propertyId, costId) =>
    api.delete(`/properties/${propertyId}/recurring-costs/${costId}`),
  getInvestment: (propertyId) => api.get(`/properties/${propertyId}/investment`),
  upsertInvestment: (propertyId, data) =>
    api.put(`/properties/${propertyId}/investment`, data),
  getTenure: (propertyId) => api.get(`/properties/${propertyId}/tenure`),
  setTenure: (propertyId, tenure) =>
    api.patch(`/properties/${propertyId}/tenure`, { tenure }),
  previewMortgage: (propertyId, data) =>
    api.post(`/properties/${propertyId}/mortgage-schedule/preview`, data),
  createMortgageSchedule: (propertyId, data) =>
    api.post(`/properties/${propertyId}/mortgage-schedule`, data),
  getCostTaxonomy: () => api.get('/admin/cost-taxonomy'),
  getMissingCosts: (year) => api.get('/admin/cost-taxonomy/missing-costs', { params: { year } }),
  getMigrationPreview: () => api.get('/admin/cost-taxonomy/migration-preview'),
};

// Recurring Cost Candidates API (portfolio cost detection)
export const recurringCostCandidatesAPI = {
  list: (params) => api.get('/recurring-cost-candidates', { params }),
  get: (id) => api.get(`/recurring-cost-candidates/${id}`),
  getProperties: (id) => api.get(`/recurring-cost-candidates/${id}/properties`),
  preview: (id, data) => api.post(`/recurring-cost-candidates/${id}/promote/preview`, data),
  promote: (id, data) => api.post(`/recurring-cost-candidates/${id}/promote`, data),
  dismiss: (id, data) => api.post(`/recurring-cost-candidates/${id}/dismiss`, data),
  undoPromote: (id) => api.post(`/recurring-cost-candidates/${id}/undo-promote`),
  runDetection: () => api.post('/recurring-cost-candidates/run-detection', null, { timeout: 120000 }),
  diagnostics: () => api.get('/admin/diagnostics/recurring-cost-detection', { timeout: 30000 }),
};

// Manual property-identity alias API (Diagnostics page) -- the overlay for
// duplicate property docs the automatic Hostaway<->Smoobu listing map can't
// express (e.g. two Uplisting docs for the same physical unit).
export const propertyAliasAPI = {
  list: () => api.get('/admin/portfolio/property-aliases'),
  create: (data) => api.post('/admin/portfolio/property-aliases', data),
  remove: (aliasId) => api.delete(`/admin/portfolio/property-aliases/${aliasId}`),
};
